export default __webpack_public_path__ + "static/media/upload.f7ce33f5.svg";